import { render, staticRenderFns } from "./SettingsUsers.vue?vue&type=template&id=ddd7984a"
import script from "./SettingsUsers.vue?vue&type=script&lang=js"
export * from "./SettingsUsers.vue?vue&type=script&lang=js"
import style0 from "./SettingsUsers.vue?vue&type=style&index=0&id=ddd7984a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports